import React from "react";

function MaintenancePage({ message }) {
  return (
    <div className="maintenance-page">
      <div className="maintenance-page__panel">
        <p className="maintenance-page__eyebrow">Maintenance mode</p>
        <h1>We&apos;ll be back shortly</h1>
        <p className="maintenance-page__message">
          {message || "We are carrying out scheduled maintenance. Please check back again soon."}
        </p>
      </div>
    </div>
  );
}

export default MaintenancePage;
